import { useState, useEffect } from 'react';
import { X, Download, Smartphone } from 'lucide-react';

export default function InstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         window.navigator.standalone === true;
    
    // Check if already dismissed
    const dismissed = localStorage.getItem('pwa-prompt-dismissed');
    
    if (isStandalone || dismissed) {
      return;
    }

    // For Android/Chrome - listen for beforeinstallprompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // For iOS - show custom prompt after delay
    if (iOS) {
      setTimeout(() => setShowPrompt(true), 3000);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowPrompt(false);
      }
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-in slide-in-from-bottom-4">
      <div className="bg-gradient-to-br from-[#1a1a2e] to-[#0f0f1a] border border-cyan-500/30 rounded-2xl p-4 shadow-2xl shadow-cyan-500/10">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-gradient-to-br from-cyan-500/20 to-purple-500/20 rounded-xl">
            <Smartphone className="w-6 h-6 text-cyan-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-white font-bold text-lg mb-1">ثبّت HELCOO</h3>
            <p className="text-gray-400 text-sm mb-3">
              {isIOS 
                ? 'اضغط على زر المشاركة ثم "إضافة إلى الشاشة الرئيسية"'
                : 'ثبّت التطبيق على جهازك للوصول السريع'
              }
            </p>
            {!isIOS && (
              <button
                onClick={handleInstall}
                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-500 rounded-xl text-white font-medium text-sm hover:opacity-90 transition-opacity"
              >
                <Download className="w-4 h-4" />
                تثبيت التطبيق
              </button>
            )}
          </div>
          <button 
            onClick={handleDismiss}
            className="p-1 hover:bg-white/10 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
